import {
  Paper as MantinePaper,
  type PaperProps as MantinePaperProps,
} from "@mantine/core";
import type { CoreComponentProps, PolymorphicProps } from "../../types";
import { useShouldRender } from "../../../hooks/useShouldRender";

export type PaperProps = CoreComponentProps<MantinePaperProps, 'div'> &
  PolymorphicProps;

export function Paper({ testId, view = "all", ...rest }: PaperProps) {
  const shouldRender = useShouldRender(view);
  if (!shouldRender) return null;
  return <MantinePaper data-testid={testId} {...(rest as MantinePaperProps)} />;
}
